'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dDerived$002dVar from "./com.raquo.airstream.state.-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits$0024$002dRich$002dSource$0024 from "./com.raquo.laminar.api.-Implicits$-Rich-Source$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024 from "./dev.cheleb.scalamigen.-Form$package$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_magnolia1$002e$002dSealed$002dTrait$0024$002dSubtype$002dValue from "./magnolia1.-Sealed-Trait$-Subtype-Value.js";
import * as $j_scala$002e$002dConsole$0024 from "./scala.-Console$.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$$anon$13(sealedTrait$2) {
  this.Hr = null;
  this.Ho = null;
  this.Hp = null;
  this.Hq = false;
  this.Hr = sealedTrait$2;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_Form$$anon$13 as $c_Ldev_cheleb_scalamigen_Form$$anon$13 };
$p = $c_Ldev_cheleb_scalamigen_Form$$anon$13.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$$anon$13;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$$anon$13() {
}
export { $h_Ldev_cheleb_scalamigen_Form$$anon$13 as $h_Ldev_cheleb_scalamigen_Form$$anon$13 };
$h_Ldev_cheleb_scalamigen_Form$$anon$13.prototype = $p;
$p.dJ = (function() {
  return this.Ho;
});
$p.BI = (function() {
  if ((!this.Hq)) {
    this.Hp = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.QO();
    this.Hq = true;
  }
  return this.Hp;
});
$p.dt = (function(x$1) {
  this.Ho = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  var a = variable.a4().b3().C();
  var x = ("Rendering sealed trait: " + a);
  $j_scala$002e$002dConsole$0024.$m_s_Console$().Cg().xu((x + "\n"));
  var this$5 = this.Hr;
  var ix$tailLocal1 = 0;
  while (true) {
    if ((ix$tailLocal1 >= this$5.iQ.a.length)) {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), (((("The given value `" + a) + "` is not a sub type of `") + this$5.k8) + "`"));
    }
    var arr$1 = this$5.iQ;
    var n = ix$tailLocal1;
    var sub = arr$1.a[n];
    if ((!sub.de(a))) {
      ix$tailLocal1 = ((1 + ix$tailLocal1) | 0);
      continue;
    }
    var x0 = new $j_magnolia1$002e$002dSealed$002dTrait$0024$002dSubtype$002dValue.$c_Lmagnolia1_SealedTrait$SubtypeValue(sub, a);
    var va = new $j_com$002eraquo$002eairstream$002estate$002e$002dDerived$002dVar.$c_Lcom_raquo_airstream_state_DerivedVar(variable, new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0, a) => ((na$2) => {
      try {
        return x0.wc.j(na$2);
      } catch (e) {
        return x0.wc.j(a);
      }
    }))(x0, a)), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$2, x$2$2) => x$2$2)), this.BI(), ".zoom");
    $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$();
    $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits$0024$002dRich$002dSource$0024.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().NJ(va.v3, variable.uI());
    return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(x0.wc.rq().bt(path, va, factory, errorBus), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.r3().w($j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(path))]));
  }
});
var $d_Ldev_cheleb_scalamigen_Form$$anon$13 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$$anon$13, "dev.cheleb.scalamigen.Form$$anon$13", ({
  j1: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$$anon$13 as $d_Ldev_cheleb_scalamigen_Form$$anon$13 };
